var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto",attrs:{"loading":_vm.loading}},[_c('v-card-subtitle',[_vm._v(_vm._s(_vm.titulo))]),_c('v-card-text',[_c('p',{staticClass:"display-1 text--primary"},[_vm._v(" "+_vm._s(_vm.cantidad)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }